<template>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-header">
        <h3>Nouvelle reception ( CLIENT )</h3>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="custom-search">
          <div class="row">
            <!-- <div v-if="isLoader">
            <div id="loading-bg">
              <div class="loading">
                <div class="effect-1 effects"></div>
                <div class="effect-2 effects"></div>
                <div class="effect-3 effects"></div>
              </div>
            </div>
          </div> -->
            <div class="col-md-9">
              <div class="from-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  class="form-control"
                  v-model="codeColis"
                />
              </div>
            </div>            
           <div class="col-md-3">
              <button type="button" class="btn btn-primary mt-3" @click="getCstmr" >
                <i class="flaticon-search"></i>
              </button>
            </div>
            <div class="col-md-12">
                <hr>
            </div>

            <div class="col-md-4">
              <div class="from-group">
                <label>Store:</label>
                  <v-select
                      :options="clientsList"
                      class="custom-select-height"
                      v-model="cstmrColi"
                      label="customer_name"
                      @search="onSearchClients">
                        <template v-slot:no-options>
                          Taper un mot pour chercher un store
                        </template>
                        <template v-slot:option="option">
                          <span>{{ option.customer_name}} - {{ option.nb_colis}} (Colis)</span>
                        </template>
                  </v-select>
              </div>
            </div>
             <div class="col-md-4">
              <div class="from-group">
                <label>Agence:</label>
                    <v-select
                    class="custom-select-height"
                        label="name"
                        :options="agencyList"
                        placeholder="Agence"
                        v-model="agency"></v-select>
              </div>
            </div>
            <div class="col-md-4">
              <button v-if="auth.can('ADD_RECEPTION')"
                type="button" class="btn btn-outline-primary mt-3"
                @click="addCstmrColi"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>

     <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-header">
        <h3>Nouvelle reception ( GLOBAL )</h3>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="from-group">
                <label>Agence :</label>
                <v-select
                class="custom-select-height"
                  label="name"
                  v-model="gobalAgency"
                  :options="agencyList"
                  placeholder="Agence"></v-select>
                 <!-- @search="onSearchAgencies"
                    >
                  <template slot="no-options">
                    Taper un mot pour chercher une agence
                  </template>
                </v-select> -->
              </div>
            </div>
   
            <div class="col-md-3">
              <button v-if="auth.can('ADD_RECEPTION')"
                type="button" class="btn btn-outline-primary mt-3"
                @click="addGlobalNote"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

     <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-header">
        <h3>Nouvelle reception ( STOCK )</h3>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="from-group">
                <label>Agence :</label>
                <v-select
                  label="stock_agency_name"
                  class="custom-select-height"
                  v-model="stockAgency"
                  :options='agencyStockList'
                  placeholder="Agence"
                >
                <template v-slot:option="option">
                    <span>{{ option.stock_agency_name}} - {{ option.nb_colis}} Colis</span>
                </template>
                </v-select>
              </div>
            </div>
    
            <div class="col-md-3">
              <button v-if="auth.can('ADD_RECEPTION')"
                type="button" class="btn btn-outline-primary mt-3"
                @click="addStockNote"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, onMounted } from "vue";
    import { ref, reactive } from "vue";

export default defineComponent({
  setup() {


    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    // Use Vue's reactive state management for variables

    const agencyList = ref([]);
    const clientsList = ref([]);
    interface CstmrColi {
      customer?: string | number;
      magasin_id?: string | number;
      customer_name?: string;
      [key: string]: any;
    }
    const cstmrColi = ref<CstmrColi>({});
    const agencyStockList = ref([]);
    const codeColis = ref('');
    const isLoader = ref(false);
    const agency = ref<{ id?: number; name?: string; id_zone?: number; zone_name?: string }>({});
    const gobalAgency = ref<{ id?: number; name?: string; id_zone?: number; zone_name?: string }>({});
    const stockAgency = ref<{ stock_agency?: number; stock_agency_name?: string; id_zone?: number; zone_name?: string }>({});

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/AgencyRamass`);

        agencyList.value = response.data;
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      }

      try {
        const response = await api.get(`/api/auth/ColiAgencyStock`);

        agencyStockList.value = response.data;
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      }
    });


    const onSearchAgencies = async (search: string, loading: (state: boolean) => void) => {
      if (search.length && agencyList.value.length === 0) {
        loading(true);
        try {
          const res = await api.get(`/api/auth/AgencyRamass`);
          agencyList.value = res.data;
        } finally {
          loading(false);
        }
      }
    };

    const onSearchAgencyStock = async (search: string, loading: (state: boolean) => void) => {
      if (search.length && agencyStockList.value.length === 0) {
        loading(true);
        try {
          const res = await api.get(`/api/auth/ColiAgencyStock`);
          agencyStockList.value = res.data;
        } finally {
          loading(false);
        }
      }
    };

    const onSearchClients = async (search: string, loading: (state: boolean) => void) => {
      if (search.length && clientsList.value.length === 0) {
        loading(true);
        try {
          const res = await api.get(`/api/auth/CstmrBL`);
          clientsList.value = res.data;
        } finally {
          loading(false);
        }
      }
    };
    const getCstmr = async () => {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/colis_cstmr`, { params: { code: codeColis.value } });
        isLoader.value = false;
        if (res.data.message == "success") {
          cstmrColi.value = res.data.cstmer;
          console.log(cstmrColi.value);
        } else if (res.data.message == 'not exist') {
          showToast('Colis n\'existe pas', "error");
        }
      } catch {
        showToast('Something went wrong! Pleaz try again', "error");
      }
    };

    const addCstmrColi = async () => {
      if (Object.keys(cstmrColi.value).length == 0 || Object.keys(agency.value).length == 0) {
        
        showToast('Merci de choisir un store et une agence', "error");
      } else {
        let data = new FormData();
        data.append('cstmr_id', String(cstmrColi.value.customer));
        data.append('magasin_id', String(cstmrColi.value.magasin_id));
        data.append('cstmr_name', cstmrColi.value.customer_name);
        data.append('agency_id', String(agency.value.id));
        data.append('agency_name', agency.value.name);
        data.append('id_zone', String(agency.value.id_zone));
        data.append('zone_name', agency.value.zone_name);
        data.append('user_id', user?.id);
        data.append('user_name', user?.name);
        data.append('type', 'CSTMR');
        isLoader.value = true;
        try {
          const res = await api.post(`/api/auth/Add_BRC`, data);
          isLoader.value = false;
          if (res.data.message == "success") {
            
            const routeData = router.resolve({ name: 'AddReceptionHCPage', params: { id: cstmrColi.value.customer, refNote: res.data.BrcRef.note_ref } });
            window.open(routeData.href, '_blank');
          }
        } catch {
          
          showToast('Something went wrong! Pleaz try again', "error");
        }
      }
    };

    const addGlobalNote = async () => {
      if (Object.keys(gobalAgency.value).length == 0) {
        showToast('Merci de choisir une agence', "error");
      } else {
        let data = new FormData();
        data.append('cstmr_id', '0');
        data.append('agency_id', String(gobalAgency.value.id));
        data.append('agency_name', gobalAgency.value.name);
        data.append('id_zone', String(gobalAgency.value.id_zone));
        data.append('zone_name', gobalAgency.value.zone_name);
        data.append('user_id', user?.id);
        data.append('user_name', user?.name);
        data.append('type', 'GLOBAL');
        isLoader.value = true;
        try {
          const res = await api.post(`/api/auth/Add_BRC`, data);
          isLoader.value = false;
          if (res.data.message == "success") {
            router.push({ name: 'AddReceptionGlobalPage', params: { id: res.data.BrcRef.note_customer, refNote: res.data.BrcRef.note_ref } });
          }
        } catch {
          
          showToast('Something went wrong! Pleaz try again', "error");
        }
      }
    };

    const addStockNote = async () => {
      if (Object.keys(stockAgency.value).length == 0) {
        
        showToast('Merci de choisir une agence', "error");
      } else {
        let data = new FormData();
        data.append('cstmr_id', '0');
        data.append('agency_id', String(stockAgency.value.stock_agency));
        data.append('agency_name', stockAgency.value.stock_agency_name);
        data.append('id_zone', String(stockAgency.value.id_zone));
        data.append('zone_name', stockAgency.value.zone_name);
        data.append('user_id', user?.id);
        data.append('user_name', user?.name);
        data.append('type', 'STOCK');
        isLoader.value = true;
        try {
          const res = await api.post(`/api/auth/Add_BRC`, data);
          isLoader.value = false;
          if (res.data.message == "success") {
            
            router.push({ name: 'AddReceptionStockPage', params: { id: res.data.BrcRef.note_customer, refNote: res.data.BrcRef.note_ref } });

          }
        } catch {
          
          showToast('Something went wrong! Pleaz try again', "error");
        }
      }
    }
      
    return {
      auth,
      agencyList,
      clientsList,
      cstmrColi,
      agencyStockList,
      codeColis,
      isLoader,
      agency,
      gobalAgency,
      stockAgency,
      getCstmr,
      addCstmrColi,
      addGlobalNote,
      addStockNote,
      onSearchClients,
      onSearchAgencyStock,
      onSearchAgencies
    };
      
  },
});
</script>
